import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quotesList: [],
  totalPages: 0,
};

export const QuotesSlice = createSlice({
  name: "quotes",
  initialState,
  reducers: {
    setquotesList: (state, action) => {
      state.quotesList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
  },
});

export const { setquotesList } = QuotesSlice.actions;

export default QuotesSlice.reducer;
